(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/cylinder-wrapper/assets/product-cylinder.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/cylinder-wrapper/assets/product-cylinder.js');
'use strict';

var _svs$core$config$data;
const breakPoints = ['--screen-xs', '--screen-sm', '--screen-am'];

const getCSSVariableFromClass = (className, variable) => {
  const element = document.querySelector(className);
  if (element) {
    var _getComputedStyle$get;
    return ((_getComputedStyle$get = getComputedStyle(element).getPropertyValue(variable)) === null || _getComputedStyle$get === void 0 ? void 0 : _getComputedStyle$get.replace('px', 'w')) || '1w';
  }
  return '1w';
};
const getBreakPoints = () => breakPoints.map(breakPoint => getCSSVariableFromClass('.cylinder', breakPoint));
const CDN = (_svs$core$config$data = svs.core.config.data.svsconfig.cdn) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : '';

const ProductCylinder = _ref => {
  let {
    game = 'lotto',
    position = 0,
    isProduct = true
  } = _ref;
  const [breakPoints, setBreakPoints] = React.useState(getBreakPoints());
  React.useLayoutEffect(() => {
    setBreakPoints(getBreakPoints());
  }, []);
  const getImageSize = size => "".concat(CDN, "/images/tb-ui/product-cylinders/").concat(game, "@").concat(size, "x.png");
  return React.createElement("img", {
    alt: game,
    className: "cylinder cylinder-".concat(game, " cylinder-").concat(position).concat(isProduct ? ' cylinder-product' : '')
    ,
    src: getImageSize(6),
    srcSet: "".concat(getImageSize(6), " ").concat(breakPoints[0], ",\n         ").concat(getImageSize(6), " ").concat(breakPoints[1])
  });
};
svs.tb_ui_react.cylinder_wrapper.ProductCylinder = ProductCylinder;

 })(window);